<template>
  <BaseSection
    :id="id"
    :name="name"
    :default-name="
      $t('message.storeLocator.extraInfo.linkSection.defaultTitle')
    "
    :is-deleting="isDeleting"
    @move-up="$emit('move-up')"
    @move-down="$emit('move-down')"
    @edit="$emit('edit')"
    @delete-section="$emit('delete-section')"
  >
    <template #icon>
      <img src="@/static/store-locator/link.svg" alt="Link" />
    </template>
    <template #content>
      <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-footer="true"
        disable-sort
      >
        <template v-slot:item.actions="{ item }">
          <v-menu left :offset-x="true" origin="left top" nudge-top="11">
            <template #activator="{ on }">
              <v-icon v-on="on">icon-more </v-icon>
            </template>
            <ui-button
              icon="icon-trash"
              iconColor="red"
              @click="$emit('delete-row', item.id)"
            >
              {{ $t("message.common.delete") }}
            </ui-button>
          </v-menu>
        </template>
      </v-data-table>
    </template>
  </BaseSection>
</template>

<script>
import BaseSection from "@/components/StoreLocator/sections/BaseSection.vue";

export default {
  name: "LinkSection",
  components: { BaseSection },
  props: {
    id: Number,
    name: String,
    items: Array,
    isDeleting: Boolean
  },
  data() {
    return {
      headers: [
        {
          text: this.$t(
            "message.storeLocator.extraInfo.linkSection.columns.text"
          ),
          value: "text"
        },
        {
          text: this.$t(
            "message.storeLocator.extraInfo.linkSection.columns.url"
          ),
          value: "url"
        },
        { text: "", value: "actions", align: "end", width: "50px" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: top;
}

.content {
  display: flex;
  flex-direction: row;
  align-items: top;
}
</style>
